import { useRemoveNoteMutation } from '@entities/clients/rtk-query.ts';
import { useAppDispatch } from '@shared/hooks';
import { openDialogModal, showPopup } from 'library/redux/modal';

export const useRemoveNote = ({ id, onSuccess }: { id: number; onSuccess?: () => void }) => {
  const dispatch = useAppDispatch();

  const [removeNoteMutation] = useRemoveNoteMutation();

  const remove = async () => {
    try {
      await removeNoteMutation(id);
      dispatch(showPopup({ type: 'success', text: 'Заметка удалена' }));
      onSuccess?.();
    } catch (error) {
      console.error();
      dispatch(showPopup({ type: 'error', text: 'Не удалось удалить заметку' }));
    }
  };

  const removeNote = () => {
    dispatch(
      openDialogModal({
        title: 'Удаление заметки',
        text: 'Вы действительно хотите удалить заметку?',
        confirmText: 'Да, удалить',
        confirm: remove,
        declineText: 'Отмена',
      })
    );
  };

  return {
    removeNote,
  };
};
